import React, { useEffect, useState, lazy, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import "./client.css";
import { HeadersCentral } from "../../layouts/headers-central/headers-central";
import { MainContent } from "../../layouts/MainContent";
import { Headers } from "../../layouts/headers/headers";
import ClientFilter from "../../components/filters/filterClients";
import { ClientList } from "../../components/datatable/ClientList";
import { getAllowClient } from "../../interpreter/clients";
import { useAuth } from "../../contexts/authContexts";

// ✅ Lazy load de modales
const UserModal = lazy(() => import("../../components/modals/profileUser"));
const ResetPasswordModal = lazy(() => import("../../components/modals/resetPassword"));
const ResetDataTechnician = lazy(() => import("../../components/modals/resetDataTechnician"));
const PermissionDeniedModal = lazy(() => import("../../components/modals/denegPermisse"));

const Client = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [activeModal, setActiveModal] = useState(null); // 'user', 'reset', 'data'
  const [showPermissionModal, setShowPermissionModal] = useState(false);

  const { user } = useAuth();
  const navigate = useNavigate(); 
  const tienePermiso = user?.permissions?.some(p => p.name === "manage-clients");

  useEffect(() => {
    if (!tienePermiso) setShowPermissionModal(true);
  }, [tienePermiso]);

  const closePermissionModal = () => {
    setShowPermissionModal(false);
    navigate("/Control-Tecnico");
  };

  const openModal = (modalType, client) => {
    setSelectedClient(client);
    setActiveModal(modalType);
  };

  const closeModal = () => {
    setActiveModal(null);
    setSelectedClient(null);
  };

  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <Headers />

      {/* Main Content */}
      <MainContent>
        <HeadersCentral 
          showDropdown={showDropdown} 
          setShowDropdown={setShowDropdown} 
          openModal={() => openModal('user')} 
        />

        <main className="p-6">
          <h1 className="text-2xl font-bold mb-7">Panel de Control de Clientes</h1>
          <ClientFilter setClients={setClients} getAllClients={getAllowClient} />
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <ClientList clients={clients} openModal={openModal} setClients={setClients} />
          </div>
        </main>
      </MainContent>
      {/* Modales */}
      <Suspense fallback={null}>
        {showPermissionModal && (
          <PermissionDeniedModal
            isOpen={showPermissionModal}
            onClose={closePermissionModal}
          />
        )}
        {activeModal === 'user' && <UserModal isOpen={true} onClose={closeModal} />}
        {activeModal === 'reset' && (
          <ResetPasswordModal isOpen={true} onClose={closeModal} user={selectedClient} userType="Cliente" />
        )}
        {activeModal === 'data' && (
          <ResetDataTechnician isOpen={true} onClose={closeModal} user={selectedClient} userType="Cliente" />
        )}
      </Suspense>
    </div>
  );
};

export default Client;
